import * as React from "react";
import styled from "../../../styled/index";
import { BaseInputCSS } from "../input/index";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const TextareaComponent = styled("textarea")<TextareaProps>`
  ${BaseInputCSS};
  font-family: ${({theme}) => theme.font.body};
  line-height: ${({theme}) => theme.input.fontSize + 4}px;
  padding-top: 10px;
  min-height: 90px;
`;

export const Textarea = (props: TextareaProps) => (
  <TextareaComponent {...props}/>
);
